import 'react';
import { jsx } from '@emotion/core';

function DrawableDottedLineField(_ref) {
  var field = _ref.field,
      className = _ref.className;
  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  return jsx("rect", {
    className: className,
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "none",
    stroke: "black",
    strokeDasharray: "5 5",
    strokeWidth: 2
  });
}

DrawableDottedLineField.displayName = "DrawableDottedLineField";
export default DrawableDottedLineField;